<script lang="ts">
	import { PUBLIC_GTM } from '$env/static/public';
	import { scriptInlineTag } from '$lib/script-inline-tag';

	console.log('PUBLIC_GTM', PUBLIC_GTM);
</script>

<!-- Google Tag Manager -->
<svelte:head>
	{#if PUBLIC_GTM}
		{@html scriptInlineTag(
			`(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
            new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
            j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
            'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
            })(window,document,'script','dataLayer','${PUBLIC_GTM}');`,
			{
				async: false,
				defer: false
			}
		)}
	{/if}
</svelte:head>
<!-- End Google Tag Manager -->
